import { Box, Chip, Typography } from '@mui/material';

export const DemReconAIInsights = () => {

  const data = {
    chips: [
      '100% matching',
      '0 outstanding',
      'All discrepancies reconciled',
      'Total $579K'
    ],
    oneLineSummary:
      'All discrepancies for the open month are fully reconciled, with total exposure down 70% versus the 3‑month average and no remaining unresolved dollars.',
    bulletPoints: [
      'Total discrepancy dollars are $579K (−70% vs 3‑month average), with $0 remaining unresolved and 100% matching achieved for the open month.',
      'All discrepancy dollars were fully reconciled across PHS ($513K), Commercial ($55K), and FSS ($11K), with no outstanding exposure in any channel.',
      'Given zero open balances, current risk is operationally closed; monitoring should focus on preventing recurrence rather than burning down residuals.'
    ],
    fullSummary:
      'For the open month, total discrepancy dollars are $579K—down 70% versus the trailing 3‑month average—with 100% of amounts fully reconciled and no unresolved exposure remaining. Reconciliation activity is distributed across PHS ($513K), Commercial ($55K), and FSS ($11K), and there are no outstanding discrepancies in any channel, confirming a clean ERP-to-RCM tie‑out for the period. From a trend perspective, several channels exhibit large historical volatility—most notably US Gross Sales, PHS, Medicaid, and ADAP in 2025Q1—but none of this volatility is manifesting as open risk in the current month. Overall, the dashboard indicates a materially improved control state versus recent history, with discrepancy management shifting from resolution to sustainment and early detection.'
  };

  return (
    <>
      {/* KPI chips */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1.5 }}>
        {data.chips.map(chip =>
          <Chip
            key={chip}
            label={chip}
            variant="filled"
            sx={{ bgcolor: 'rgba(255,255,255,0.16)', color: 'inherit' }}
          />
        )}
      </Box>

      {/* TL;DR */}
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        {data.oneLineSummary}
      </Typography>

      {/* Bulleted highlights */}
      <Box component="ul" sx={{ pl: 2.5, mt: 0, mb: 1.5, '& li': { mb: 0.5 } }}>
        {data.bulletPoints.map((bulletPoint, index) =>
          <li key={index}>
            <Typography variant="body2">
              {bulletPoint}
            </Typography>
          </li>
        )}
      </Box>

      {/* Original narrative (narrow measure for readability) */}
      <Typography variant="body2" sx={{ lineHeight: 1.25 }}>
        {data.fullSummary}
      </Typography>

      {/* Micro-CTAs */}
      {/* <Box sx={{ display: 'flex', gap: 1.25, mt: 'auto', pt: 2 }}>
              <Button
                variant="contained"
                size="small"
                startIcon={<i className={fas.faBug} />}
                onClick={() => {
                  // example: open a filtered view for outliers
                  // setStartPeriod(...); setEndPeriod(...); setProdIds([...]);
                }}
              >
                View Outliers
              </Button>
              <Button
                variant="outlined"
                size="small"
                startIcon={<i className={fas.faLightbulb} />}
                onClick={() => {
                  // example: navigate to driver drilldown
                }}
                sx={{ color: 'inherit', borderColor: 'rgba(255,255,255,0.35)' }}
              >
                Driver Drilldown
              </Button>
            </Box> */}
    </>
  )
}